var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      !_vm.isXml && !_vm.readOnly
        ? _c(
            "b-row",
            { staticClass: "mb-1" },
            [
              _c(
                "b-col",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c("e-button", {
                    attrs: {
                      text: _vm.$t("Adicionar pagamento"),
                      variant: "primary",
                    },
                    on: { click: _vm.onAddPayment },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "FormulateForm",
                { ref: "formulatePayments" },
                [
                  _c("b-table", {
                    ref: "productTable",
                    staticClass: "bordered",
                    attrs: {
                      "show-empty": "",
                      striped: "",
                      fields: _vm.fields,
                      items: _vm.payments,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(paymentMethod)",
                        fn: function (row) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex-grow-1",
                                    class: {
                                      "mr-2":
                                        _vm.isCardPaymentMethod(
                                          row.item.paymentMethodId
                                        ) ||
                                        _vm.isPixPaymentMethod(
                                          row.item.paymentMethodId
                                        ),
                                    },
                                  },
                                  [
                                    _c("e-payment-method", {
                                      attrs: {
                                        id:
                                          "invoice-payments-payment_type-" +
                                          row.index,
                                        "is-read-only": _vm.readOnly,
                                        placeholder: _vm.$t(
                                          "Clique para selecionar"
                                        ),
                                        label: "",
                                        required: "",
                                        "validation-messages": {
                                          required: _vm.$t(
                                            "Este campo é obrigatório"
                                          ),
                                        },
                                        flag: _vm.getPaymentMethodFlag,
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.handleSwitchChange(
                                            row.item
                                          )
                                        },
                                      },
                                      model: {
                                        value: row.item.paymentMethodId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            row.item,
                                            "paymentMethodId",
                                            $$v
                                          )
                                        },
                                        expression: "row.item.paymentMethodId",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mb-2" },
                                  [
                                    (_vm.isCardPaymentMethod(
                                      row.item.paymentMethodId
                                    ) ||
                                      _vm.isPixPaymentMethod(
                                        row.item.paymentMethodId
                                      )) &&
                                    !_vm.readOnly
                                      ? _c("FormulateInput", {
                                          attrs: {
                                            disabled: _vm.isCardPaymentMethod(
                                              row.item.paymentMethodId
                                            ),
                                            instruction: _vm.$t(
                                              "Ative para pagamento Manual e mantenha desativado para pagamento POS"
                                            ),
                                            type: "switch",
                                            label: "Manual?",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.handleSwitchChange(
                                                row.item,
                                                $event
                                              )
                                            },
                                          },
                                          model: {
                                            value: row.item.isManual,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                row.item,
                                                "isManual",
                                                $$v
                                              )
                                            },
                                            expression: "row.item.isManual",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm.isNsuRequired(row.item)
                              ? _c(
                                  "div",
                                  { staticClass: "flex-grow-1" },
                                  [
                                    !_vm.readOnly
                                      ? _c(
                                          "FormulateInput",
                                          _vm._b(
                                            {
                                              key: "nsu",
                                              staticClass: "required",
                                              attrs: {
                                                type: "number",
                                                label: "",
                                                validation: "required|matches",
                                                "validation-rules": {
                                                  matches: function (ref) {
                                                    var value = ref.value

                                                    return /^(?!0+$)\d+$/.test(
                                                      value
                                                    )
                                                  },
                                                },
                                                "validation-messages": {
                                                  required: _vm.$t(
                                                    "O NSU é obrigatório para a forma de pagamento selecionada"
                                                  ),
                                                  matches: _vm.$t(
                                                    "O NSU deve ser um número válido"
                                                  ),
                                                },
                                                placeholder: _vm.$t("NSU"),
                                              },
                                              model: {
                                                value: row.item.nsu,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row.item,
                                                    "nsu",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "row.item.nsu",
                                              },
                                            },
                                            "FormulateInput",
                                            _vm.$attrs,
                                            false
                                          )
                                        )
                                      : _vm.readOnly && row.item.nsu
                                      ? _c(
                                          "FormulateInput",
                                          _vm._b(
                                            {
                                              attrs: {
                                                value: "NSU: " + row.item.nsu,
                                                type: "label",
                                              },
                                            },
                                            "FormulateInput",
                                            _vm.$attrs,
                                            false
                                          )
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm.isPixPaymentMethod(
                                  row.item.paymentMethodId
                                ) && row.item.isManual
                              ? _c(
                                  "div",
                                  { staticClass: "flex-grow-1" },
                                  [
                                    !_vm.readOnly
                                      ? _c(
                                          "FormulateInput",
                                          _vm._b(
                                            {
                                              key: "cpfCnpj",
                                              attrs: {
                                                type: "text-mask",
                                                mask: [
                                                  "###.###.###-##",
                                                  "XX.XXX.XXX/XXXX-##",
                                                ],
                                                label: "",
                                                validation: ["cpfcnpj"],
                                                "validation-rules": {
                                                  cpfcnpj: function (ref) {
                                                    var value = ref.value

                                                    return (
                                                      !value ||
                                                      _vm.validateTitularDocument(
                                                        value
                                                      )
                                                    )
                                                  },
                                                },
                                                "validation-messages": {
                                                  cpfcnpj: _vm.$t(
                                                    "Digite um CPF ou CNPJ válido"
                                                  ),
                                                },
                                                placeholder: _vm.$t(
                                                  "Documento do titular"
                                                ),
                                              },
                                              model: {
                                                value: row.item.cpfCnpj,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row.item,
                                                    "cpfCnpj",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "row.item.cpfCnpj",
                                              },
                                            },
                                            "FormulateInput",
                                            _vm.$attrs,
                                            false
                                          )
                                        )
                                      : _vm.readOnly && row.item.cpfCnpj
                                      ? _c(
                                          "FormulateInput",
                                          _vm._b(
                                            {
                                              attrs: {
                                                value:
                                                  "Documento do titular: " +
                                                  row.item.cpfCnpj,
                                                type: "label",
                                              },
                                            },
                                            "FormulateInput",
                                            _vm.$attrs,
                                            false
                                          )
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.showE2EIdPix(row.item)
                              ? _c(
                                  "div",
                                  { staticClass: "flex-grow-1" },
                                  [
                                    _c(
                                      "FormulateInput",
                                      _vm._b(
                                        {
                                          attrs: {
                                            value:
                                              "Id da transação (E2E Id): " +
                                              row.item
                                                .authorizationApprovalCode,
                                            type: "label",
                                          },
                                        },
                                        "FormulateInput",
                                        _vm.$attrs,
                                        false
                                      )
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "cell(paymentValue)",
                        fn: function (row) {
                          return [
                            !_vm.readOnly
                              ? [
                                  !_vm.canPaymentValueBeZero(row.item)
                                    ? _c("FormulateInput", {
                                        staticClass: "text-right",
                                        attrs: {
                                          id:
                                            "invoice-payments-payment_value-" +
                                            row.index,
                                          type: "text-number",
                                          currency: "R$",
                                          precision: 3,
                                          validation: "required|min:0.01",
                                          "validation-messages": {
                                            required: _vm.$t(
                                              "Este campo é obrigatório"
                                            ),
                                            min: _vm.$t(
                                              "Este campo deve ser maior que 0.01"
                                            ),
                                          },
                                        },
                                        model: {
                                          value: row.item.paymentValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              row.item,
                                              "paymentValue",
                                              $$v
                                            )
                                          },
                                          expression: "row.item.paymentValue",
                                        },
                                      })
                                    : _c("FormulateInput", {
                                        staticClass: "text-right",
                                        attrs: {
                                          id:
                                            "invoice-payments-payment_value-" +
                                            row.index,
                                          type: "text-number",
                                          currency: "R$",
                                          precision: 3,
                                          validation: "required",
                                          "validation-messages": {
                                            required: _vm.$t(
                                              "Este campo é obrigatório"
                                            ),
                                          },
                                        },
                                        model: {
                                          value: row.item.paymentValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              row.item,
                                              "paymentValue",
                                              $$v
                                            )
                                          },
                                          expression: "row.item.paymentValue",
                                        },
                                      }),
                                ]
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(row.item.paymentValue)
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "cell(changeValue)",
                        fn: function (row) {
                          return [
                            !_vm.readOnly
                              ? _c("FormulateInput", {
                                  staticClass: "text-right",
                                  attrs: {
                                    id:
                                      "invoice-payments-payment_change_value-" +
                                      row.index,
                                    type: "text-number",
                                    currency: "R$",
                                    precision: 3,
                                  },
                                  model: {
                                    value: row.item.changeValue,
                                    callback: function ($$v) {
                                      _vm.$set(row.item, "changeValue", $$v)
                                    },
                                    expression: "row.item.changeValue",
                                  },
                                })
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(row.item.changeValue)
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "cell(dueDate)",
                        fn: function (row) {
                          return [
                            !_vm.readOnly
                              ? _c("FormulateInput", {
                                  staticClass: "text-right",
                                  attrs: {
                                    id:
                                      "invoice-payments-payment_duedate-" +
                                      row.index,
                                    type: "datepicker",
                                  },
                                  model: {
                                    value: row.item.dueDate,
                                    callback: function ($$v) {
                                      _vm.$set(row.item, "dueDate", $$v)
                                    },
                                    expression: "row.item.dueDate",
                                  },
                                })
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(_vm._f("date")(row.item.dueDate))
                                  ),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "cell(action)",
                        fn: function (row) {
                          return [
                            _c("e-grid-actions", {
                              attrs: {
                                "show-update": false,
                                "show-delete": true,
                              },
                              on: {
                                delete: function ($event) {
                                  return _vm.onRemovePayment(row.item)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }